import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "auto", zIndex:1000 }}>
      <h1>MotoMate Privacy Policy</h1>
      <p><strong>Effective Date:</strong> June 25, 2025</p>

      <p>MotoMate ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by MotoMate.</p>
      <p>By using our app, you agree to the collection and use of information in accordance with this policy.</p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li><strong>Personal Information:</strong> such as your name, email address, or login credentials if you create an account.</li>
        <li><strong>Usage Data:</strong> service logs, mileage records, or interactions within the app.</li>
        <li><strong>Device Information:</strong> non-personal data like device type, OS version, etc.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide and maintain the app's core features</li>
        <li>To improve the user experience</li>
        <li>To send service reminders and notifications</li>
        <li>To detect bugs and improve performance</li>
      </ul>

      <h2>3. Data Storage & Security</h2>
      <p>All user data is stored securely and is not shared with third parties. We implement technical measures to prevent unauthorized access.</p>

      <h2>4. Third-Party Services</h2>
      <p>We may use services like Expo, Firebase, or Vercel for hosting or analytics. These services may collect data under their own policies.</p>

      <h2>5. User Control & Deletion</h2>
      <p>You may request deletion of your data by contacting us at:</p>
      <p><strong>Email:</strong> contact@neupanesugam.com.np</p>

      <h2>6. Children's Privacy</h2>
      <p>MotoMate is not intended for children under the age of 13. We do not knowingly collect personal data from children.</p>

      <h2>7. Changes to This Policy</h2>
      <p>We may update this privacy policy at any time. Updates will be posted on this page with the new effective date.</p>

      <h2>8. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, you can contact us:</p>
      <p><strong>Email:</strong> contact@neupanesugam.com.np</p>
    </div>
  );
};

export default PrivacyPolicy;
